//-- Copyright (c) 2021 TMT Insights Group, LLC
import { useEffect } from 'react';
import IngestManagementTitleBar from './IngestManagementBar/IngestManagementTitleBar';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { setCurrentTable } from '@/redux/slices/dataTableSlice';
import DataTableFilters from '@/components/_common/Filters/DataTableFilters';
import { useConfigValue } from '../_hooks/useConfigValue';
import IngestManagementChart from './IngestManagementChart';
import styled from '@emotion/styled';
import { IngestManagementConfig } from '@/__configs/config_types';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useToast } from '../_common/Toast';
import PolarisTableContainer from '../_common/Table/PolarisTableContainer/PolarisTableContainer';
import TableContainer from '../_common/Table/TableContainer';

const IngestManagement = () => {
  const dispatch = useAppDispatch();
  const currentTableKey = useAppSelector(selectCurrentTableKey);
  const version = useConfigValue(['ingestManagementConfig', 'version']) || 'v1';
  const { success } = useToast();

  window.addEventListener('message', (event) => {
    if (event.origin === window.origin && event.data === 'Successfully ingested record') {
      success('Successfully ingested record');
    }
  });

  useEffect(() => {
    dispatch(setCurrentTable('fileIngest'));
  }, []);

  return (
    <>
      {currentTableKey === 'fileIngest' && (
        <>
          <StyledIngestManagementTitleBar version={version} />
          {version === 'v2' && <IngestManagementChart />}
          <DataTableFilters disableExportReport />
          {version === 'v2' ? <PolarisTableContainer /> : <TableContainer />}
        </>
      )}
    </>
  );
};
export default IngestManagement;

const StyledIngestManagementTitleBar = styled(IngestManagementTitleBar)<{
  version: IngestManagementConfig['version'];
}>`
  ${({ version }) =>
    version === 'v2' &&
    `
  margin-bottom: 0px !important;
  `}
`;
